"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.QUICK_LINK_MEDIA_ASPECT_RATIO = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _reactImageCrop = _interopRequireDefault(require("react-image-crop"));

var _Button = _interopRequireDefault(require("@insided/shared/uikit/Button"));

var _utils = require("./utils");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var QUICK_LINK_MEDIA_ASPECT_RATIO;
exports.QUICK_LINK_MEDIA_ASPECT_RATIO = QUICK_LINK_MEDIA_ASPECT_RATIO;

(function (QUICK_LINK_MEDIA_ASPECT_RATIO) {
  QUICK_LINK_MEDIA_ASPECT_RATIO[QUICK_LINK_MEDIA_ASPECT_RATIO["IMAGE"] = 2.333] = "IMAGE";
  QUICK_LINK_MEDIA_ASPECT_RATIO[QUICK_LINK_MEDIA_ASPECT_RATIO["ICON"] = 1] = "ICON";
})(QUICK_LINK_MEDIA_ASPECT_RATIO || (exports.QUICK_LINK_MEDIA_ASPECT_RATIO = QUICK_LINK_MEDIA_ASPECT_RATIO = {}));

var AddQuickLinkImageCropper = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(AddQuickLinkImageCropper, _Component);

  var _super = _createSuper(AddQuickLinkImageCropper);

  function AddQuickLinkImageCropper(props) {
    var _this$props$aspectRat;

    var _this;

    (0, _classCallCheck2.default)(this, AddQuickLinkImageCropper);
    _this = _super.call(this, props);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "csrf", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      pixelCrop: null,
      crop: {
        x: 0,
        y: 0,
        height: 80,
        aspect: (_this$props$aspectRat = _this.props.aspectRatio) !== null && _this$props$aspectRat !== void 0 ? _this$props$aspectRat : QUICK_LINK_MEDIA_ASPECT_RATIO.IMAGE
      },
      isLoading: false
    });
    var element = document.getElementById('csrftoken');

    if (element) {
      _this.csrf = element.value;
    }

    _this.saveImage = _this.saveImage.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(AddQuickLinkImageCropper, [{
    key: "saveImage",
    value: function () {
      var _saveImage = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
        var _this$props, fileBlob, onUseImage, pixelCrop, data;

        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.setState({
                  isLoading: true
                });
                _this$props = this.props, fileBlob = _this$props.fileBlob, onUseImage = _this$props.onUseImage;
                pixelCrop = this.state.pixelCrop;
                _context.prev = 3;
                _context.next = 6;
                return (0, _utils.uploadCroppedImageRequest)({
                  fileBlob: fileBlob,
                  csrf: this.csrf,
                  pixelCrop: pixelCrop
                });

              case 6:
                data = _context.sent;
                onUseImage(data.source_thumb);
                _context.next = 12;
                break;

              case 10:
                _context.prev = 10;
                _context.t0 = _context["catch"](3);

              case 12:
                _context.prev = 12;
                this.setState({
                  isLoading: false
                });
                return _context.finish(12);

              case 15:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[3, 10, 12, 15]]);
      }));

      function saveImage() {
        return _saveImage.apply(this, arguments);
      }

      return saveImage;
    }()
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$state = this.state,
          pixelCrop = _this$state.pixelCrop,
          crop = _this$state.crop,
          isLoading = _this$state.isLoading;
      var _this$props2 = this.props,
          uploadImageInputId = _this$props2.uploadImageInputId,
          fileSource = _this$props2.fileSource,
          onCancel = _this$props2.onCancel;
      return (0, _preact.h)("div", {
        className: "quick-links-manager__add-quick-link-image-cropper"
      }, (0, _preact.h)("h3", {
        className: "quick-links-manager__add-quick-link-image-cropper-title"
      }, "Crop image"), (0, _preact.h)("p", null, "We\u2019d recommend to upload a high-quality image with 21:9 ratio to make the link card more visual. Supported image formats are JPG, PNG, and GIF, and max 5MB."), (0, _preact.h)("div", null, pixelCrop === null || pixelCrop === void 0 ? void 0 : pixelCrop.width, "*", pixelCrop === null || pixelCrop === void 0 ? void 0 : pixelCrop.height, "px selected"), (0, _preact.h)(_reactImageCrop.default, {
        src: (0, _absoluteUrlRuntime.resolveUrl)(fileSource),
        crop: crop,
        onChange: function onChange(crop, pixelCrop) {
          return _this2.setState({
            crop: crop,
            pixelCrop: pixelCrop
          });
        }
      }), (0, _preact.h)("div", {
        className: "quick-links-manager__add-quick-link-image-cropper-actions"
      }, (0, _preact.h)(_Button.default, {
        type: "button",
        variant: "success"
      }, (0, _preact.h)("label", {
        htmlFor: uploadImageInputId
      }, "Choose a new image")), (0, _preact.h)(_Button.default, {
        type: "button",
        className: "btn--insided-secondary-brand",
        onClick: function onClick() {
          return onCancel();
        }
      }, "Cancel"), (0, _preact.h)(_Button.default, {
        type: "button",
        variant: "primary",
        isLoading: isLoading,
        className: "quick-links-manager__add-quick-link-image-cropper-actions-use qa-quicklinks-upload-image",
        onClick: /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
          return _regenerator.default.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  _context2.next = 2;
                  return _this2.saveImage();

                case 2:
                  return _context2.abrupt("return", _context2.sent);

                case 3:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        }))
      }, "Use image")));
    }
  }]);
  return AddQuickLinkImageCropper;
}(_preact.Component);

var _default = AddQuickLinkImageCropper;
exports.default = _default;